import _util from '../../utils/';


const notificationTemplateServcie = {
	selectNotificationTemplate(gets, resolve, reject) {
		_util.request({
			url: '/api/HRNotificationTemplate/Get',
			params: gets,
			success: resolve,
			error: reject
		})
	},
	deleteNotificationTemplate(gets, resolve, reject) {
		_util.request({
			url: '/api/HRNotificationTemplate/Delete',
			method: "delete",
			data: gets,
			success: resolve,
			error: reject
		})
	},
	createNotificationTemplate(posts, resolve, reject) {
		_util.request({
			url: '/api/HRNotificationTemplate/Post',
			method: "post",
			data: posts,
			success: resolve,
			error: reject
		})
	},
	updateNotificationTemplate(puts, resolve, reject) {
		_util.request({
			url: '/api/HRNotificationTemplate/Put',
			method: "put",
			data: puts,
			success: resolve,
			error: reject
		})
	}
};


export default notificationTemplateServcie;


// WEBPACK FOOTER //
// ./src/services/Recruitment/notification-template-service.js